import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const BoxRadioV2 = ({
  children,
  name,
  selected,
  onClick,
  value,
  className,
  ...props
}) => (
  <WrapperBg
    bgColor={backgroundColors.normalLeft}
    className={`${className} ${selected && 'selected'}`}
    {...props}>
    <Wrapper onClick={onClick} className={selected && 'selected'} tabIndex='1'>
      <Input
        bgColor={backgroundColors.normalLeft}
        id={`opt-${value}-${name}`}
        name={name}
        checked={selected}
        onChange={onClick}
      />
      {children}
    </Wrapper>
  </WrapperBg>
)

export default BoxRadioV2

const WrapperBg = styled.div`
  height: 40px;
  max-width: 74px;
  background: ${({ bgColor }) => bgColor};
  padding: 1px;
  flex-grow: 1;
  cursor: pointer;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  padding: 8px;
  flex: 1 0 0;
  background: #fff;

  &:hover {
    background: #ececec;
  }

  &.selected {
    background: transparent;

    > p {
      color: #fff;
    }

    svg,
    path {
      fill: #fff;
    }
  }
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  width: 20px !important;
  height: 20px !important;
  border: none !important;
  position: relative;
  z-index: 1;
  cursor: pointer;
  display: none;
`



// WEBPACK FOOTER //
// ./src/components/BoxRadioV2/index.js